import { render, staticRenderFns } from "./benefits-faq-form.vue?vue&type=template&id=062dfec0&scoped=true"
import script from "./benefits-faq-form.vue?vue&type=script&lang=js"
export * from "./benefits-faq-form.vue?vue&type=script&lang=js"
import style0 from "./benefits-faq-form.vue?vue&type=style&index=0&id=062dfec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062dfec0",
  null
  
)

export default component.exports